import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  ContClientsSection,
  TitleClients,
  ClientsGrid,
  ClientItem,
  ClientLogo,
} from './CoreBancarioClients.styles';

import CapitlaLogo from '../../assets/images/CoreBankingModulesImages/ourClients/Capitla.svg';
import GluLogo from '../../assets/images/CoreBankingModulesImages/ourClients/Glu.svg';
import InclusivityLogo from '../../assets/images/CoreBankingModulesImages/ourClients/Inclusivity.svg';
import KluLogo from '../../assets/images/CoreBankingModulesImages/ourClients/Klu.svg';
import RapicreditLogo from '../../assets/images/CoreBankingModulesImages/ourClients/Rapicredit.svg';

const clients = [
  {
    id: 1,
    logo: CapitlaLogo,
    name: 'Capitla',
  },
  {
    id: 2,
    logo: InclusivityLogo,
    name: 'Inclusivity',
  },
  {
    id: 3,
    logo: KluLogo,
    name: 'Klu',
  },
  {
    id: 4,
    logo: GluLogo,
    name: 'Glu',
  },
  {
    id: 5,
    logo: RapicreditLogo,
    name: 'Rapicredit',
  },
];

export const CoreBancarioClients = () => {
  const { t } = useTranslation();

  return (
    <ContClientsSection>
      <TitleClients>
        {t('Nuestros Clientes')}
      </TitleClients>
      <ClientsGrid>
        {clients.map((client) => (
          <ClientItem key={client.id}>
            <ClientLogo src={client.logo} alt={client.name} />
          </ClientItem>
        ))}
      </ClientsGrid>
    </ContClientsSection>
  );
};
